import { useMountEffect } from './useMountEffect';
import { shellEventBus } from '../services/shellBridge';
import { overlaySlotStore } from '../services/overlaySlots/overlaySlotStore';

/**
 * Bridges the overlay slot store to the shell event bus:
 * - `shellOverlayOpen` on every successful `setOpen(true)` (including preemption)
 * - `shellOverlayClose` when the shared overlay fully closes
 *
 * Mount-only external subscription — genuine `useMountEffect` case.
 */
export function useOverlaySlotBroadcast(): void {
  useMountEffect(() => {
    let prevOpenSeq = overlaySlotStore.getSnapshot().openSeq;
    let prevCloseSeq = overlaySlotStore.getSnapshot().closeSeq;
    return overlaySlotStore.subscribe(() => {
      const snap = overlaySlotStore.getSnapshot();
      if (snap.openSeq !== prevOpenSeq) {
        shellEventBus.emit('shellOverlayOpen');
        prevOpenSeq = snap.openSeq;
      }
      if (snap.closeSeq !== prevCloseSeq) {
        shellEventBus.emit('shellOverlayClose');
        prevCloseSeq = snap.closeSeq;
      }
    });
  });
}
